import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import classNames from 'classnames'
import React from 'react'

const styles = () =>
  createStyles({
    root: {
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      display: 'flex',
      width: '100%',
      boxSizing: 'border-box',
    },
  })

interface ICardHeaderProps extends WithStyles<typeof styles> {
  children: React.ReactNode
  className?: string
}

const CardHeader = (props: ICardHeaderProps) => {
  const { classes, className, children } = props

  return <div className={classNames(classes.root, className)}>{children}</div>
}

export default withStyles(styles)(CardHeader)
